<template>
    <v-flex xs12 sm12 d-block class="card-dados">
        <h3 class="card-dados__titulo">Dados do Processo</h3>
        <v-layout wrap align-center white>
            <v-flex xs12 sm3 d-flex>
                <div id="numeroProcesso" class="az-text">
                    <label>Nº Processo</label>
                    <p>
                        {{value.processo ? value.processo : '--'}}
                        <span v-if="value.quantidadeRepeticoes">
                            - <strong> Repetição: {{value.quantidadeRepeticoes}} </strong>
                        </span>
                    </p>
                </div>
            </v-flex>
            <v-flex xs12 sm3 d-flex>
                <div id="orgao" class="az-text">
                    <label>{{ $t('main.commons_painel_processo_visualizacao.text') }}</label>
                    <p>{{comprador}}</p>
                </div>
            </v-flex>
            <v-flex xs12 sm12 d-flex>
                <div id="objeto" class="az-text">
                    <label>Objeto</label>
                    <p>{{value.objeto ? value.objeto : '--'}}</p>
                </div>
            </v-flex>
        </v-layout>
    </v-flex>
</template>

<script>
export default {
    name: 'PainelProcessoVisualizacao',
    props: {
        value: {
            required: true
        }
    },
    computed:{
        ehPerfilFornecedor() {
            return this.$store.state.loki.user.type === 'EXTERNO'
        },
        comprador(){
            if(this.value.comprador){
                if(this.ehPerfilFornecedor) {
                    return this.value.comprador.sigla
                }
                return this.value.comprador.nome + ' - ' + this.value.comprador.sigla
            }
            return '--'
        }
    }
}
</script>
